export enum WkIdType {
  WKID3763 = 3763,
  WKID5016 = 5016,
  WKID5014 = 5014,
  WKID5015 = 5015,
  WKID3857 = 3857,
  WKID4326 = 4326,
}

export const wkidLabelDictionary = new Map<WkIdType, string>([
  [WkIdType.WKID3763, 'ETRS 1989 Portugal TM06'],
  [WkIdType.WKID5016, 'PTRA08 UTM Zone 28N'],
  [WkIdType.WKID5014, 'PTRA08 UTM Zone 25N'],
  [WkIdType.WKID5015, 'PTRA08 UTM Zone 26N'],
  [WkIdType.WKID3857, 'WGS 1984 Web Mercator Auxiliary Sphere'],
  [WkIdType.WKID4326, 'GCS WGS 1984'],
]);
